module.exports = __webpack_public_path__ + "img/menu.72ee2043.svg";